export default __webpack_public_path__ + "static/media/desktop.67bf13c1.png";